'use strict'
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'

import './style/common.less'
import './utils/rem'
import './filters'

import App from './App.vue'
import Toast from './components/toast'
import Loading from './components/loading'

Vue.use(Vuex)
Vue.use(Toast)
Vue.use(Loading)

export default function ({ router = {} }) {
    Vue.use(VueRouter)
    const Router = new VueRouter({
        mode: 'history',
        routes: router.routes
    })
    Router.beforeEach((to, from, next) => {
        if (to.meta.title) {
            document.title = to.meta.title
        }
        next()
    })
    Router.afterEach(() => {
        window.scrollTo(0, 0)
    })
    const store = new Vuex.Store()
    App.store = store
    new Vue({
        router: Router,
        render: h => h(App)
    }).$mount('#app')
    window.router = Router
}
